import {
  Button,
  DatePicker,
  Pagination,
  Select,
  Spin,
  Table,
  Tag,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import { FaRegAddressCard } from "react-icons/fa";
import { ThemeColor } from "../../../Theme/theme";

import {
  nsdlRequest,
} from "../../../ApiServices/Apifun";
import CommonInput from "../../../Common/CommonInput";
import { AiOutlineSearch } from "react-icons/ai";
import { dispatchtoast, formatDateAndTime, trimString } from "../../../Utils";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setselectedTab } from "../../../Store/B2bslice";

const PanServices = () => {
  const [btnLoading, setBtnLoading] = useState({
    generateNewPanReqest: false,
    generateCorrectionRequest: false,
  });
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleGenerate = (key) => {
    setBtnLoading({ ...btnLoading, [key]: true });
    nsdlRequest(key)
      .then((res) => {
        if (res.status) {
          window.open(res.data.redirect_url, "_blank");
        }
      })
      .catch((err) => console.log(err))
      .finally(() =>
        setBtnLoading({
          generateNewPanReqest: false,
          generateCorrectionRequest: false,
          generateCrReq: false,
        })
      );
  };
  useEffect(() => {
    dispatch(setselectedTab("16"));
    if (!memberServices.includes("19")) {
      navigate("/not-Available");
    }
  }, []);
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 place-items-center">
        <section class="container w-full">
          <div class="card w-full">
            <div class="content">
              <FaRegAddressCard color={ThemeColor.primary} size={50} />
              <h6>New Pan </h6>
              <div class="">
               
                <div className="flex justify-end items-center mt-6">
                  <Button
                    loading={btnLoading.generateNewPanReqest}
                    onClick={() => handleGenerate("generateNewPanReqest")}
                    className="bg-primary outline-none border-none text-white hover:outline-none focus:border-none"
                  >
                    Generate Pan
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="container">
          <div class="card">
            <div class="content">
              <FaRegAddressCard color={ThemeColor.primary} size={50} />
              {/* <img class="logo" src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/76882/logo.svg" alt="mparticle"/> */}
              <h6>Correction Pan </h6>
              <div class="">
                <div className="flex justify-end items-center mt-6">
                  <Button
                    loading={btnLoading.generateCorrectionRequest}
                    onClick={() => handleGenerate("generateCorrectionRequest")}
                    className="bg-primary outline-none border-none text-white hover:outline-none focus:border-none"
                  >
                    Generate Pan
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div></div>
      </div>
    </>
  );
};

export default PanServices;
